import axios from 'axios';

const withCredentials = { withCredentials: true };

const normalizePriceRuralBase = (value) => {
    if (value === null || value === undefined || value === '') {
        return '0';
    }
    return String(value);
};

const readBoolean = (...values) => {
    for (const value of values) {
        if (value !== undefined && value !== null) {
            return Boolean(value);
        }
    }
    return false;
};

export const buildWhatsappConfigPayload = (config) => ({
    id: config.id,
    orderStartTime: config.orderStartTime ?? null,
    orderEndTime: config.orderEndTime ?? null,
    deliveryType: config.deliveryType,
    idDelivery: config.idDelivery,
    shopBranchId: config.shopBranchId,
    status: readBoolean(config.status),
    verifyAddress: readBoolean(config.verifyAddress),
    // Jackson/Lombok esperan estos nombres en JSON, no isPriceActive/isMessageWppActive/isRuralSettings.
    priceActive: readBoolean(config.priceActive, config.isPriceActive),
    messageWppActive: readBoolean(config.messageWppActive, config.isMessageWppActive),
    ruralSettings: readBoolean(config.ruralSettings, config.isRuralSettings),
    priceRuralBase: normalizePriceRuralBase(config.priceRuralBase),
});

export const updateWhatsappConfig = async (config) => {
    const response = await axios.put(
        process.env.REACT_APP_API_MODULES_CONFIGS_UPDATE_ROUTE,
        buildWhatsappConfigPayload(config),
        withCredentials
    );
    return response.data;
};

export const updateDeliveryCommonConfig = async (deliveryConfig) => {
    const response = await axios.put(
        process.env.REACT_APP_API_MODULES_CONFIGS_DELIVERY_UPDATE_ROUTE,
        deliveryConfig,
        withCredentials
    );
    return response.data;
};

export const updateDeliveryCustomConfig = async (deliveryConfig) => {
    const response = await axios.put(
        process.env.REACT_APP_API_MODULES_CONFIGS_DELIVERY_CUSTOM_UPDATE_ROUTE,
        deliveryConfig,
        withCredentials
    );
    return response.data;
};
